// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '@localytics/loc-components/lib/Icon';
import './Page.scss';

const NotFound = ({ orgId }: { orgId: number }) => (
  <div className="Page__Body">
    <div
      className="Page__Content Page__Content--flexible Page__404"
      style={{ flexDirection: 'column' }}
    >
      <Icon icon="alert" />
      <div> This page cannot be found. </div>
      <div>
        Return to{' '}
        {orgId !== null ? (
          <Link
            to={{
              pathname: '/all',
              search: `?orgId=${orgId}`
            }}
          >
            all Campaigns
          </Link>
        ) : (
          <a href="https://dashboard.localytics.com">Dashboard</a>
        )}
      </div>
    </div>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/NotFound.jsx